import { Dict } from './types'

export const filterUndefined = (obj: Dict) => {
  const newObj: Dict = {}
  Object.keys(obj).forEach((key) => {
    if (obj[key] === Object(obj[key])) newObj[key] = filterUndefined(obj[key])
    else if (obj[key] !== undefined) newObj[key] = obj[key]
  })
  return newObj
}
